const firebaseConfig = {
    apiKey: 'AIzaSyDp2GLvHmqnuFmjcWdv9ou5sv74WjAkbps',
    authDomain: 'alamin-creative-agency.firebaseapp.com',
    databaseURL: 'https://alamin-creative-agency.firebaseio.com',
    projectId: 'alamin-creative-agency',
    storageBucket: 'alamin-creative-agency.appspot.com',
    messagingSenderId: '173439260091',
    appId: '1:173439260091:web:ddb9526bb70c5d2eb9a09e',
};
export default firebaseConfig;
